import vodafoneWS2Theme from '../../theme/vodafone-ws2';
import vodafoneWS10Theme from '../../theme/vodafone-ws10';
import ziggoWS2Theme from '../../theme/ziggo-ws2';
import { Themes } from './theme.models';
/** Typing makes sure that you can only add a key to this object if it is
 * also added to the Themes enum. And the value of these objects should
 * always equal the ThemeSettings interface. */
const settings = {
    [Themes.VODAFONE_WS2]: {
        style: vodafoneWS2Theme,
        name: Themes.VODAFONE_WS2,
    },
    [Themes.VODAFONE_WS10]: {
        style: vodafoneWS10Theme,
        name: Themes.VODAFONE_WS10,
    },
    [Themes.ZIGGO_WS2]: {
        style: ziggoWS2Theme,
        name: Themes.ZIGGO_WS2,
    },
};
export default settings;
//# sourceMappingURL=theme.settings.js.map